export const OFFER_TYPE_SIMPLE   = 1;
export const OFFER_TYPE_PERSONAL = 2;
